import styled from 'styled-components'
import {
    desktopBreakpoint,
    mobileBreakpoint,
    SolidButton,
    tabletBreakpoint,
    wideScreenBreakpoint,
} from 'react-components'

import { getBasePath } from '../../../../utils/miscellaneous-utils'

export const InputWrapper = styled.div`
    position: ${props => props.theme.style.position.relative};
    color: ${props => props.theme.colors.tfwBlack12};
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        flex-direction: row;
        padding: 1rem 4.5rem 0.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.5rem 4rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 0.5rem 7.938rem;
    }
`

export const InputEmail = styled.input`
    border: 1px solid #d5d5d5;
    border-radius: 0.5rem;
    padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.medium};
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-style: normal;
    font-weight: 400;
    background-color: rgba(254, 244, 239, 0.6);
    font-size: 1rem;
    line-height: 1.5rem;
    color: #5f5f5f;
    outline: 0;
    width: ${props => props.theme.layout.fill};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-right: 1rem;
        padding: 0.45rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.75rem 1rem;
        margin-right: 1rem;
    }
`

export const InformationWrapper = styled.div`
    display: ${props => props.theme.style.display.flex};
    padding-top: calc(${props => props.theme.spacing.xxSmall} + ${props => props.theme.spacing.medium});

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1.5rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 1rem 0 0;
    }
`

export const CheckboxWrapper = styled.label`
    align-items: ${props => props.theme.style.alignItems.flexStart};
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.row};
    cursor: default;
    font-size: ${props => props.theme.typography.font.size.small};
    font-weight: 400;
`

export const CheckBox = styled.div``

export const CheckBoxText = styled.div`
    flex: 1;
    cursor: pointer;
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: #5f5f5f;
`

export const ReadMore = styled.span`
    text-decoration: underline;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.5rem;
    color: #5f5f5f;
`

export const ExtraText = styled.p`
    margin: 0;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    color: #5f5f5f;
`

export const CheckBoxLink = styled.a`
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    text-decoration: underline;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5rem;
    color: #5f5f5f;
`

export const SubmitEmail = styled.div`
    color: ${props => props.theme.colors.tfwBlack87};
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: ${props => props.theme.style.textAlign.center};
    font-weight: 400;
    align-items: ${props => props.theme.style.alignItems.center};
    margin-top: 0.5rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 0;
    }
`

export const ButtonText = styled.div`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.tfwBlack87};
    line-height: 1.5rem;
`
export const CheckBoxLabel = styled.label`
    margin-right: calc(${props => props.theme.spacing.xSmall} + ${props => props.theme.spacing.xxxSmall});
    padding: 0.5rem;
    display: ${props => props.theme.style.display.inlineBlock};
    position: ${props => props.theme.style.position.relative};
    cursor: pointer;
    font-size: ${props => props.theme.layout.fill};
    outline: 0;
    background-color: white;
    border: 1px solid #e0a080;
    border-radius: 0.25rem;
`

const checkBoxUrl = `url(${getBasePath('/assets/icons/check.svg')})`

export const InputCheckbox = styled.input`
    &:checked + ${CheckBoxLabel} {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 1.125rem;
        height: 1.125rem;
        background: ${props => props.theme.colors.white} ${checkBoxUrl} no-repeat center;
        background-size: cover;
    }

    display: none;
`

export const RegisterButton = styled(SolidButton)`
    padding: 0.75rem 1.5rem;
    border-radius: 1rem;
    width: 100%;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 9rem;
    }
    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        border-radius: 0.5rem;
    }
`
